import React from "react";
import { ArrowRight, ChevronRight } from "lucide-react";
import { NLink } from "@/i18n/I18nProvider";

const CAMPUS_IMAGE = "https://images.pexels.com/photos/35564755/pexels-photo-35564755.jpeg";

const SportTile = ({ t, s, i }) => (
  <NLink
    to={`/sports/${s.slug}`}
    data-testid={`sport-tile-${s.slug}`}
    className="group bg-[#F4F0E8] p-8 hover:bg-[#0F1B2D] transition-colors duration-500 min-h-[200px] flex flex-col justify-between"
  >
    <div className="font-display text-[#C4A46A] text-sm">0{i + 1}</div>
    <div>
      <div className="font-display text-[#0F1B2D] group-hover:text-white text-xl lg:text-2xl tracking-tight transition-colors">{s.t}</div>
      <div className="mt-3 flex items-center gap-2 text-[#5E6470] group-hover:text-[#C4A46A] text-[11px] tracking-[0.24em] uppercase font-bold transition-colors">
        {t.common.explore} <ArrowRight size={12} />
      </div>
    </div>
  </NLink>
);

export const HomeSports = ({ t }) => (
  <section data-testid="home-sports" className="bg-[#F4F0E8]">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-24 lg:py-32">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
        <div>
          <div className="overline">{t.home.sportsKicker}</div>
          <h2 className="mt-4 font-display text-[#0F1B2D] text-3xl sm:text-4xl lg:text-5xl tracking-tight">{t.home.sportsTitle}</h2>
          <span className="gold-rule mt-6 block" />
        </div>
        <NLink to="/sports" data-testid="sports-see-all" className="text-[#0F1B2D] text-[12px] tracking-[0.24em] uppercase font-bold hover:text-[#A38755] inline-flex items-center gap-2">
          {t.common.seeAll} <ChevronRight size={14} />
        </NLink>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0F1B2D]/15">
        {t.sports.list.map((s, i) => (
          <SportTile key={s.slug} t={t} s={s} i={i} />
        ))}
        <div className="bg-[#0F1B2D] p-8 min-h-[200px] flex flex-col justify-between" data-testid="other-sports-tile">
          <div className="font-display text-[#C4A46A] text-sm">04</div>
          <div>
            <div className="font-display text-white text-xl lg:text-2xl tracking-tight">{t.sports.futureT}</div>
            <div className="mt-3 text-white/70 text-sm leading-relaxed">{t.sports.futureD}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export const HomeFinalCta = ({ t }) => (
  <section data-testid="home-final-cta" className="relative grain bg-[#0F1B2D] overflow-hidden">
    <div
      className="absolute inset-0 opacity-40"
      style={{
        backgroundImage: `linear-gradient(rgba(15,27,45,0.75), rgba(15,27,45,0.9)), url(${CAMPUS_IMAGE})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-24 lg:py-32 text-center">
      <div className="overline text-[#C4A46A]">{t.common.taglineSecondary}</div>
      <h2 className="mt-6 font-display text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight">{t.home.ctaBlockTitle}</h2>
      <span className="gold-rule mt-8 block mx-auto" />
      <p className="mt-8 text-white/75 text-lg max-w-2xl mx-auto leading-relaxed">{t.home.ctaBlockBody}</p>
      <NLink
        to="/contact"
        data-testid="final-cta-button"
        className="mt-12 inline-flex items-center gap-3 px-10 py-5 bg-[#C4A46A] text-[#0F1B2D] text-[12px] tracking-[0.24em] uppercase font-bold hover:bg-[#A38755] transition-colors"
      >
        {t.nav.bookCta} <ArrowRight size={16} />
      </NLink>
    </div>
  </section>
);
